export default "<div class=\"blog\">\r\n    <section>\r\n      <p>\r\n        Blog content goes here!\r\n      </p>\r\n    </section>\r\n</div>";